import React, { useState, useEffect } from "react";
import { useUser } from "../../Home/UserContext";
import { getRoleFromRoleId } from "../../../utils/roleHelper";
import DashboardNavigation from "../../DashboardNavigation/DashboardNavigation";
import useScrollToTop from "../../../hooks/useScollToTop";
import ScrollIndicator from "./../../Home/ScrollIndicator";
import {
  getAllTechniques,
  deleteTechnique,
} from "../../../services/techniquesServices";
import TechniqueModal from "./TechniqueModal";
import ButtonEdit from "./../../../components/Button/ButtonEdit";
import ButtonDelete from "./../../../components/Button/ButtonDelete";
import Button from "./../../../components/Button/Button";

const TechniquesPage = () => {
  useScrollToTop();
  const [techniques, setTechniques] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCeinture, setSelectedCeinture] = useState(
    "Toutes les ceintures"
  );
  const [selectedFamille, setSelectedFamille] = useState("Toutes les familles");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingTechnique, setEditingTechnique] = useState(null);
  const { user } = useUser();
  const userRole = getRoleFromRoleId(user?.role_id);

  // Récupérer userId depuis localStorage
  const getUserIdFromLocalStorage = () => {
    try {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      return userInfo?.userId;
    } catch (error) {
      console.error(
        "Erreur lors de la récupération de userId depuis localStorage:",
        error
      );
      return null;
    }
  };

  const userId = getUserIdFromLocalStorage();

  useEffect(() => {
    fetchTechniques();
  }, []);

  const fetchTechniques = async () => {
    const fetchedTechniques = await getAllTechniques();
    setTechniques(fetchedTechniques);
  };

  const handleSearchChange = (e) => setSearchTerm(e.target.value.toLowerCase());
  const handleCeintureChange = (e) => setSelectedCeinture(e.target.value);
  const handleFamilleChange = (e) => setSelectedFamille(e.target.value);

  const handleEdit = (technique) => {
    setEditingTechnique(technique);
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    await deleteTechnique(id);
    fetchTechniques();
  };

  const handleAdd = () => {
    setEditingTechnique(null);
    setIsModalOpen(true);
  };

  const filteredTechniques = techniques.filter(
    (technique) =>
      (selectedCeinture === "Toutes les ceintures" ||
        technique.ceinture === selectedCeinture) &&
      (selectedFamille === "Toutes les familles" ||
        technique.famille === selectedFamille) &&
      technique.nom.toLowerCase().includes(searchTerm)
  );

  return (
    <div className="flex flex-col w-full mx-auto p-2 mt-[130px] sm:mt-[130px] md:mt-[150px] lg:mt-[150px] xl:mt-[150px] dark:text-white">
      <ScrollIndicator />
      <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light tracking-[0.4em] text-gray-800 text-center dark:text-white mb-4">
        ENSEIGNANTS
      </h2>
      <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-widest text-gray-800 text-center dark:text-white mb-4 font-satoshi uppercase">
        Gestion des Techniques
      </h2>
      <DashboardNavigation role={userRole} />

      <div className="overflow-x-auto max-w-[1280px] mx-auto w-full">
        <div className="flex flex-col sm:flex-row gap-2 w-full mb-4">
          <input
            type="text"
            className="input input-bordered w-full max-w-md dark:bg-gray-200 dark:text-black"
            placeholder="Rechercher une technique..."
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-4">
          <select
            className="select select-bordered dark:bg-gray-200 dark:text-black"
            value={selectedCeinture}
            onChange={handleCeintureChange}
          >
            <option>Toutes les ceintures</option>
            <option>Blanche</option>
            <option>Jaune</option>
            <option>Orange</option>
            <option>Verte</option>
            <option>Bleue</option>
            <option>Marron</option>
            <option>Noire</option>
            <option>1er Dan</option>
            <option>2ème Dan</option>
            <option>3ème Dan</option>
            <option>4ème Dan</option>
            <option>5ème Dan</option>
            <option>6ème Dan</option>
            <option>7ème Dan</option>
          </select>

          <select
            className="select select-bordered dark:bg-gray-200 dark:text-black"
            value={selectedFamille}
            onChange={handleFamilleChange}
          >
            <option>Toutes les familles</option>
            <option>Jambe</option>
            <option>Hanche</option>
            <option>Epaule</option>
            <option>Bras</option>
            <option>Sutemi Waza</option>
            <option>Immobilisation</option>
            <option>Shime Waza</option>
            <option>Kansetsu-Waza</option>
            <option>Self Défense</option>
            <option>Kata</option>
            <option>Vocabulaire</option>
            <option>Les Bases</option>
            <option>Ukemi</option>
          </select>
        </div>
        <Button
          text="Ajouter une technique"
          onClick={handleAdd}
          color="primary"
          className="mb-4"
        />
        <table className="table-auto w-full border-collapse border border-gray-300 dark:border-gray-600 mb-10">
          <thead>
            <tr className="bg-gray-200 dark:bg-gray-700 text-center">
              <th className="border p-2 text-center dark:text-white">
                Illustration
              </th>
              <th className="border p-2 text-center dark:text-white">Nom</th>
              <th className="border p-2 text-center dark:text-white">
                Famille
              </th>
              <th className="border p-2 text-center dark:text-white">
                Ceinture
              </th>
              <th className="border p-2 text-center dark:text-white">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredTechniques.map((technique) => (
              <tr
                key={technique.id}
                className="hover:bg-gray-100 dark:hover:bg-gray-600"
              >
                <td className="border p-2">
                  {technique.image1_url && (
                    <img
                      src={technique.image1_url}
                      alt={technique.nom}
                      className="w-16 h-16 object-cover"
                    />
                  )}
                </td>
                <td className="border p-2 font-semibold">{technique.nom}</td>
                <td className="border p-2">{technique.famille}</td>
                <td className="border p-2">{technique.ceinture}</td>
                <td className="border p-2 flex justify-center items-center gap-4">
                  <ButtonEdit onClick={() => handleEdit(technique)} />
                  <ButtonDelete onClick={() => handleDelete(technique.id)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isModalOpen && (
        <TechniqueModal
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
          technique={editingTechnique}
          refresh={fetchTechniques}
        />
      )}
    </div>
  );
};

export default TechniquesPage;
